import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface TrunkInteriorProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function TrunkInterior(props: TrunkInteriorProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Trunk"
      width={232}
      height={434}
      viewBox="0 0 232 434"
      position={{top: 34, right: 10}}
    >
      <path
        d="M79 241C79 320 46.0005 388 41 395C81 395 153.751 394.308 185 381C188.112 379.568 190.861 377.711 193 376C200.202 370.238 211.997 360.162 218 344C231 308.999 231 251.055 231 217.049V217V216.951C231 182.945 231 125.001 218 90C211.997 73.838 200.202 63.7621 193 58C190.861 56.2891 188.112 54.4319 185 53C153.751 39.6922 81 39 41 39C46.0005 46 79 114 79 193V217V241Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M185 381C181.259 387.941 178.101 393.031 176 397C169.633 409.027 161.013 420.411 134 426V425.998C118.179 429.314 59.9903 431.04 4 432C10.4 428 28 414 41 395C81 395 153.751 394.308 185 381Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M4 2C59.9903 2.96039 118.179 4.68575 134 8.00195V8C161.013 13.5888 169.633 24.9731 176 37C178.101 40.9686 181.259 46.0591 185 53C153.751 39.6922 81 39 41 39C28 20 10.4 6 4 2Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M79 241C79 320 46.0005 388 41 395C81 395 153.751 394.308 185 381C188.112 379.568 190.861 377.711 193 376C200.202 370.238 211.997 360.162 218 344C231 308.999 231 251.055 231 217.049V217V216.951C231 182.945 231 125.001 218 90C211.997 73.838 200.202 63.7621 193 58C190.861 56.2891 188.112 54.4319 185 53C153.751 39.6922 81 39 41 39C46.0005 46 79 114 79 193V217V241Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M169 386C174 383 180.861 377.711 183 376C190.202 370.238 201.997 360.162 208 344C221.006 308.982 221 251 221 217C221 183 221.006 125.018 208 90C201.997 73.838 190.202 63.7621 183 58C180.861 56.2891 174 51 169 48"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M176 37C169.633 24.9731 161.013 13.5888 134 8V8.00207C118.179 4.68586 59.9903 2.96039 4 2C10.4 6 28 20 41 39C81 39 153.751 39.6922 185 53C181.259 46.0591 178.101 40.9686 176 37Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M176 397C169.633 409.027 161.013 420.411 134 426V425.998C118.179 429.314 59.9903 431.04 4 432C10.4 428 28 414 41 395C81 395 153.751 394.308 185 381C181.259 387.941 178.101 393.031 176 397Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M51 395C56.0005 388 89 320 89 241V217V193C89 114 56.0005 46 51 39"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
